<tpm-card class="contentful-card">
  <div class="contentful-card__container" [class.mobile]="isMobileView" (click)="cardClick.emit()">
    <div class="contentful-card__teaser-image">
      <img *ngIf="data.teaserImage" [ngSrc]="data.teaserImage" fill />
    </div>
    <div class="contentful-card__content">
      <div *ngIf="data.date" class="contentful-card__content__header">
        <span class="cta-sm date-description">{{ data.date | date : "dd.MM.yyyy" }} </span>
        <tpm-colored-badge
          *ngIf="data.isNew"
          class="new-badge"
          text="Neu"
          [backgroundColor]="'--kp-color-blue-50'"
          [color]="'--kp-color-blue-700'"
        ></tpm-colored-badge>
        <mat-icon *ngIf="data.checkCritical" class="critical-badge" fontIcon="ec_warning"></mat-icon>
      </div>
      <div class="contentful-card__content-headline last-line-3 body-md">{{ data.headline }}</div>
      <div class="last-line-4 body-sm" [innerHTML]="data.teaser"></div>
    </div>
    <div class="contentful-card__actions">
      <tpm-button
        button-filled
        button-rounded
        data-cy="back-to-home-button"
        [icon]="data.mediaType ? data.mediaType === 'video' ? 'gpi-filled-circled-play' : 'gpi-filled-document': ''"
      >
        {{ buttonLabel }}
      </tpm-button>
    </div>
  </div>
</tpm-card>
